module.exports = __webpack_public_path__ + "static/fonts/iconfont.8003f000.ttf";